import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { Link } from 'react-router-dom';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { PlanAndBilling } from '@/features/w/[identifier]/setting/{components}/PlanAndBilling';
import { ConsumptionTaxRuleLogic } from '@/hooks/api/models/logics';
import { MonthlyExternalExpensesElement } from '@/features/w/[identifier]/setting/{components}/MonthlyExternalExpensesElement';
import { WorkspaceSalesOrderPhasesElement } from '@/features/w/[identifier]/setting/{components}/WorkspaceSalesOrderPhasesElement';
import { WorkspacePurchaseOrderPhasesElement } from '@/features/w/[identifier]/setting/{components}/WorkspacePurchaseOrderPhasesElement';

export const WorkspaceSetting = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('スペース設定'), []);
  useEffect(() => setBreadcrumbs([]), []);
  const { _w_, me } = useCurrentWorkspace();

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'basic'} />

        <div className="row">
          <div className="col-12 col-lg-9 mx-auto">
            <div className="card mb-4" id="basic-info">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-1">スペース基本設定</h5>
                </div>
                <div className="col-md-4 d-flex justify-content-end">
                  {me!.admin && (
                    <Link
                      to={`/w/${_w_!.identifier}/setting/edit_basic`}
                      className="btn btn-icon-only btn-outline-success"
                    >
                      <i className="fas fa-edit text-success text-sm"></i>
                    </Link>
                  )}
                </div>
              </div>
              <div className="card-body pt-0 row">
                <div className="col-auto">
                  <div className="avatar avatar-xxl position-relative">
                    <img
                      src={_w_!.logo_image_file_url}
                      alt="profile_image"
                      className="w-100 border-radius-lg shadow-sm"
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-8 mt-4 mt-sm-0">
                  <div className="form-group">
                    <label>スペース名</label>
                    <p className="form-text text-muted text-sm ms-1">{_w_!.name}</p>
                  </div>
                  <div className="form-group">
                    <label>スペースID</label>
                    <p className="form-text text-muted text-sm ms-1">{_w_!.identifier}</p>
                  </div>
                  <div className="form-group">
                    <label>決算月</label>
                    <p className="form-text text-muted text-sm ms-1">{_w_!.closing_month}月</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="card mb-4" id="basic-info">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-0">スペース個別設定</h5>
                </div>
                <div className="col-md-4 d-flex justify-content-end">
                  {me!.admin && (
                    <Link
                      to={`/w/${_w_!.identifier}/setting/edit_detail`}
                      className="btn btn-icon-only btn-outline-success"
                    >
                      <i className="fas fa-edit text-success text-sm"></i>
                    </Link>
                  )}
                </div>
              </div>
              <div className="card-body pt-0">
                <div className="form-group">
                  <label>請求書確認マニュアルリンク</label>
                  <p className="form-text text-muted text-sm ms-1">
                    {_w_!.invoice_manual_url ? (
                      <Link to={_w_!.invoice_manual_url} target="_blank">
                        {_w_!.invoice_manual_url}
                      </Link>
                    ) : (
                      <>未設定</>
                    )}
                  </p>
                </div>
                <div className="form-group">
                  <label>消費税計算ルール</label>
                  <p className="form-text text-muted text-sm ms-1">
                    {ConsumptionTaxRuleLogic.nameToLabel(_w_!.consumption_tax_rule)}
                  </p>
                </div>
              </div>
            </div>

            <MonthlyExternalExpensesElement />

            <WorkspaceSalesOrderPhasesElement />

            <WorkspacePurchaseOrderPhasesElement />

            {/* 請求書払いの場合は非表示 */}
            {!_w_!.payment_on_invoice && <PlanAndBilling />}
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
